/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Filter_Max_MinutesInputs */

const en_filter_max_minutes = /** @type {(inputs: Filter_Max_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≤ ${i?.minutes} min`)
};

const de_filter_max_minutes = /** @type {(inputs: Filter_Max_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≤ ${i?.minutes} Min.`)
};

/**
* | output |
* | --- |
* | "≤ {minutes} min" |
*
* @param {Filter_Max_MinutesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_max_minutes = /** @type {((inputs: Filter_Max_MinutesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Max_MinutesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_max_minutes(inputs)
	return en_filter_max_minutes(inputs)
});